export default {
  deleteIcon: (theme) => ({
    fontSize: 16,
    color: theme.palette.reds.codingRed400,
    transition: 'color 0.2s ease-in-out',
    '&:hover': {
      color: theme.palette.reds.codingRed600,
    },
  }),
  modalButtonsText: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: 'normal',
    '&:hover': {
      color: (theme) => theme.palette.reds.codingRed600,
    },
  },
};
